"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeLocalization = exports.default = exports.convertLangToMomentLocale = exports.convertLangToLocale = exports.UA_LOCALE = exports.UA_LANG = exports.RU_LOCALE = exports.RU_LANG = exports.RO_LOCALE = exports.PL_LOCALE = exports.PL_LANG = exports.KK_LOCALE = exports.EN_LOCALE = exports.EN_LANG = exports.DEFAULT_LANG = void 0;
var R = _interopRequireWildcard(require("ramda"));
var _i18next = _interopRequireDefault(require("i18next"));
var _reactI18next = require("react-i18next");
var _config = require("../services/config");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var newInstance = _i18next.default.createInstance();
var RU_LANG = exports.RU_LANG = 'rus';
var UA_LANG = exports.UA_LANG = 'ukr';
var EN_LANG = exports.EN_LANG = 'en';
var PL_LANG = exports.PL_LANG = 'pl';
// after add new lang patch google langs map components/Map/store/selectors

var DEFAULT_LANG = exports.DEFAULT_LANG = RU_LANG;
var RU_LOCALE = exports.RU_LOCALE = 'ru';
var UA_LOCALE = exports.UA_LOCALE = 'uk_UA';
var EN_LOCALE = exports.EN_LOCALE = 'en';
var KK_LOCALE = exports.KK_LOCALE = 'kk';
var RO_LOCALE = exports.RO_LOCALE = 'ro_RO';
var PL_LOCALE = exports.PL_LOCALE = 'pl_PL';
var DEFAULT_LOCALE = RU_LOCALE;
var convertLangToLocale = exports.convertLangToLocale = function convertLangToLocale(lang) {
  return R.call(R.cond([[R.equals(RU_LANG), R.always(RU_LOCALE)], [R.equals(UA_LANG), R.always(UA_LOCALE)], [R.equals(EN_LANG), R.always(EN_LOCALE)], [R.equals(PL_LANG), R.always(PL_LOCALE)], [R.T, R.always(DEFAULT_LOCALE)]]), lang);
};
var getLocaleFile = function getLocaleFile(locale) {
  return R.call(R.cond([[R.equals(RU_LOCALE), function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require(/* ru-locale-json */"./locales/ru.json"));
    });
  }], [R.equals(UA_LOCALE), function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require(/* uk-locale-json */"./locales/uk.json"));
    });
  }], [R.equals(EN_LOCALE), function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require(/* en-locale-json */"./locales/en.json"));
    });
  }], [R.equals(PL_LOCALE), function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require(/* pl-locale-json */"./locales/pl.json"));
    });
  }], [R.T, function () {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require(/* ru-locale-json */"./locales/ru.json"));
    });
  }]]), locale);
};
var convertLangToMomentLocale = exports.convertLangToMomentLocale = function convertLangToMomentLocale(lang) {
  return R.call(R.cond([[R.equals(RU_LANG), R.always('ru')], [R.equals(UA_LANG), R.always('uk')], [R.equals(EN_LANG), R.always('en')], [R.equals(PL_LANG), R.always('pl')], [R.T, R.always(DEFAULT_LOCALE)]]), lang);
};
var initializeLocalization = exports.initializeLocalization = function initializeLocalization() {
  return R.call(function (locale) {
    return getLocaleFile(locale).then(function (_ref) {
      var jsonFile = _ref.default;
      return newInstance.use(_reactI18next.initReactI18next).init({
        debug: __DEV__,
        keySeparator: false,
        lng: locale,
        react: {
          nsMode: 'fallback'
        },
        resources: _defineProperty({}, locale, jsonFile)
      });
    });
  }, convertLangToLocale((0, _config.getLang)() || DEFAULT_LANG));
};
var _default = exports.default = newInstance;